import {ChevronRightIcon} from '@heroicons/react/24/outline'
import {ReactNode, useEffect, useState} from 'react'
import {AccountManagementRoleSearchUser} from '../../../components/account/admin/AccountManagementRoleSearchUser'
import {
    AccountManagementRolesWithUsersList
} from '../../../components/account/admin/AccountManagementRolesWithUsersList'
import {useSearchParams} from 'react-router-dom'
import UtilsHelper from "../../../helpers/utilsHelper.ts";
import AccountLayout from "../../../components/layouts/AccountLayout.tsx";

export const ButtonNav = (title: string, description: string, onClick: Function): ReactNode => (
    <button
        className='relative group bg-neutral-900 max-w-lg mb-4 py-10 px-10 rounded-3xl flex w-full items-center justify-between hover:bg-neutral-700 transition-colors'
        onClick={() => onClick()}
    >
        <div className='text-left'>
            <p className='text-2xl'>{title}</p>
            <p className='text-neutral-400 mt-2'>{description}</p>
        </div>
        <ChevronRightIcon className='w-10 h-10'/>
    </button>
)

export const AccountManagementRolePage = () => {
    const [selectedView, setSelectedView] = useState<"SEARCH_USER" | "ALL_ROLES_WITH_USERS" | null>(null);
    const [searchParams, setSearchParams] = useSearchParams();
    UtilsHelper.changeWindowDocumentTitle("Zarzadzanie uprawnieniami");

    useEffect(() => {
        const view = searchParams.get('view') as "SEARCH_USER" | "ALL_ROLES_WITH_USERS" | null;
        if (view === "SEARCH_USER" || view === "ALL_ROLES_WITH_USERS" || view === null) {
            setSelectedView(view);
        } else {
            setSelectedView(null);
        }
    }, [searchParams])


    return (
        <AccountLayout>
            {selectedView === null && <>
                {ButtonNav("Dodaj uprawnienia", "Dodaj uprawnienia dla użytkownika", () => {
                    setSearchParams({view: "SEARCH_USER"})
                })}
                {ButtonNav("Edytuj uprawnienia", "Zarządzaj uprawnieniami użytkowników", () => {
                    setSearchParams({view: 'ALL_ROLES_WITH_USERS'})
                })}
            </>}
            {selectedView === 'SEARCH_USER' &&
                <AccountManagementRoleSearchUser/>
            }
            {selectedView === 'ALL_ROLES_WITH_USERS' &&
                <AccountManagementRolesWithUsersList/>
            }
        </AccountLayout>
    )
}